import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import instance from "../../services/ApiServices";
import { motion } from "motion/react";
import ProductCart from "./ProductCart";

const DrinksMenu = () => {
  const isEven = (num) => num % 2 === 0;
  // const params = useParams();
  // const enquiredevent=params.eventId
  const endpoint = "search-menucategory/drinks";
  const [Menucategory, setMenucategory] = useState([]);
  useEffect(() => {
    // call Data from api
    instance.get(endpoint).then((res) => {
      const newValue = [];
      const datas = res.data;
      datas.forEach((data) => {
        // data['image']=JSON.parse(data['image'])
        newValue.push(data);
      });
      console.log(JSON.stringify(newValue));
      setMenucategory(newValue);
    });
  }, []);

  return (
    <div className="container pb-10">
      <h1 className="text-4xl lg:text-6xl font-semibold pt-10">Drinks Menu</h1>

      {Menucategory.map((menu, index) => (
        <div
          className="sm:flex flex-row my-5 mb-20 bg-slate-100"
          key={index}
        >
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            viewport={{ once: true }}
            whileInView={{
              x: 0,
              opacity: 1,
              transition: {
                delay: 0.5,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 0.6 },
                ease: "easeIn",
              },
            }}
            className="justify-center
    items-center
    overflow-hidden"
          >
            <img
              className="object-cover w-full"
              src={menu.image}
              alt=""
            />
          </motion.div>
        </div>
      ))}
    </div>
  );
};

export default DrinksMenu;
